module.exports = __webpack_public_path__ + "img/defaultPhoto.jpg";